import { render, staticRenderFns } from "./TenantLogo.vue?vue&type=template&id=162bf1d7"
import script from "./TenantLogo.vue?vue&type=script&lang=js"
export * from "./TenantLogo.vue?vue&type=script&lang=js"
import style0 from "./TenantLogo.vue?vue&type=style&index=0&id=162bf1d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports